export default __webpack_public_path__ + "static/media/phone3.6956d47d.jpg";